<template>
    <main-content with_go_back_bar>
        <kt-panel>
            <kt-form-label style="margin-top: 20px;margin-right: 10px" for="serial_number">
                {{ $t('pos.rollback') }}
            </kt-form-label>
            <hr style="width:100%">
            <kt-panel-body>
                <form @submit.prevent="submit" id="rollback">
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="rollback_reason_id">
                                    {{ $t('pos.rollback_reason_id') }}
                                </kt-form-label>
                                <select
                                        id="rollback_reason_id"
                                        name="rollback_reason_id"
                                        v-model="form_data.rollback_reason_id"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-for="(value,index) in customer_data.rollback_reasons"
                                            :value="index"
                                    >
                                        {{ value }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="description">
                                    {{ $t('pos.description') }}
                                </kt-form-label>
                                <textarea
                                        id="description"
                                        v-model="description"
                                        class="col-lg-12 col-md-12 col-sm-6 description_text_area"
                                        dir="ltr">
                                 </textarea>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-form-action class="mt-4">
                        <kt-button
                                class="m-2"
                                size="md"
                                variant="success"
                                @click="sendData"
                                v-bind:wide="true"
                                id="submit_btn"
                        >
                            {{ $t('panel.profile.update.wizard.form.btn.submit') }}
                        </kt-button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import $ from "jquery";
import {KTApp} from '@/plugins/core/app'
import {posService} from '@/common/api.service'
import {mapGetters} from "vuex";
import {i18n} from "@/plugins/i18n";


export default {
    components: {
        'main-content': mainContent,
    },
    computed: {
        ...mapGetters('pos', [
            'customer_data'
        ]),
    },
    mounted() {
        this.$store.dispatch('pos/fetch').finally(() => {
            this.afterDispatch()
        })
    },
    methods: {
        afterDispatch() {
            setTimeout(
                    $('.kt-selectpicker').selectpicker({
                        size: 6,
                        liveSearch: false,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_chose')

                    }), 2000)


        },
        sendData(e) {
            let form = $('#rollback')
            let btn = $('#submit_btn')
            this.form_data.followup_code = this.$route.params.followup_code
            this.form_data.terminal_id = this.$route.params.terminal_id

            KTApp.progress(btn)

            posService.posRollback(this.form_data).then(response => {
                this.$router.push('/pos')
            })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
        }
    },
    data() {
        return {
            form_data: {},
        }
    },
}
</script>

<style>
.description_text_area{
    min-height: 80px;
}
.no-border{
    border: none;
    background: none;
}
</style>